const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "60px",
    width: "60px",
    id: "Layer_1",
    viewBox: "0 0 392.525 392.525",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M337.034,55.527c-44.865-44.865-117.98-44.865-162.909,0s-44.865,117.98,0,162.909  s117.98,44.865,162.909,0S381.899,100.457,337.034,55.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M321.002,71.56c-36.073-36.073-94.707-36.073-130.844,0s-36.073,94.707,0,130.844  s94.707,36.073,130.844,0C357.01,166.331,357.01,107.632,321.002,71.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M352.485,40.077c-53.398-53.398-140.347-53.398-193.745,0  c-45.446,45.446-52.17,115.135-20.234,167.822l-26.57,26.57c-14.481-1.228-29.285,3.62-40.275,14.61l-56.824,56.824  c-19.782,19.782-19.782,51.976,0,71.758s51.976,19.782,71.758,0l56.824-56.824c11.055-11.055,15.838-25.859,14.61-40.275  l26.57-26.57c52.687,31.935,122.376,25.212,167.822-20.299C405.883,180.424,405.883,93.539,352.485,40.077z M128.032,305.58  l-56.824,56.824c-11.313,11.313-29.673,11.313-40.986,0s-11.313-29.673,0-40.986l56.824-56.824  c11.313-11.313,29.673-11.313,40.986,0C139.345,275.907,139.281,294.202,128.032,305.58z M150.271,257.677  c-1.939-3.038-4.202-5.883-6.788-8.469c-2.65-2.65-5.495-4.848-8.469-6.788l16.485-16.485c2.327,2.715,4.719,5.43,7.37,7.952  c2.521,2.521,5.236,5.042,7.952,7.37L150.271,257.677z M337.034,218.436c-44.865,44.865-117.98,44.865-162.909,0  s-44.865-117.98,0-162.909s117.98-44.865,162.909,0S381.899,173.507,337.034,218.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M151.434,225.871l-16.485,16.485c3.038,1.939,5.883,4.202,8.469,6.788s4.848,5.495,6.788,8.469  l16.485-16.485c-2.715-2.327-5.43-4.719-7.952-7.37C156.154,231.236,153.762,228.521,151.434,225.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M128.032,305.58c11.313-11.313,11.313-29.673,0-40.986c-11.313-11.313-29.673-11.313-40.986,0  l-56.824,56.824c-11.313,11.313-11.313,29.673,0,40.986s29.673,11.313,40.986,0L128.032,305.58z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M299.927,118.752c-4.267,4.267-4.267,11.119,0,15.45c4.267,4.267,11.119,4.267,15.451,0   c18.166-18.166,18.166-47.774,0-66.004c-4.267-4.267-11.119-4.267-15.451,0c-4.267,4.267-4.267,11.119,0,15.451   C309.624,93.345,309.624,109.055,299.927,118.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M267.863,152.562c4.267-4.267,4.267-11.119,0-15.451c-14.739-14.739-38.853-14.739-53.657,0   c-4.267,4.267-4.267,11.119,0,15.451c4.267,4.267,11.119,4.267,15.451,0c6.271-6.271,16.549-6.271,22.82,0   C256.679,156.828,263.596,156.828,267.863,152.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M279.952,91.988c4.267-4.267,4.267-11.119,0-15.451c-4.267-4.267-4.267-11.055,0-15.321   s4.267-11.119,0-15.451c-4.267-4.267-11.119-4.267-15.451,0c-12.735,12.735-12.735,33.487,0,46.158   C268.703,96.255,275.685,96.255,279.952,91.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M339.038,153.273c-4.267-4.267-11.119-4.267-15.451,0c-5.947,5.947-15.515,5.947-21.463,0   c-4.267-4.267-11.119-4.267-15.451,0c-4.267,4.267-4.267,11.119,0,15.451c14.481,14.481,37.883,14.481,52.299,0   C343.305,164.521,343.305,157.604,339.038,153.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M179.556,100.133c4.267,4.267,11.184,4.202,15.451-0.065c7.37-6.788,17.713-5.818,23.208,0l0,0   c4.267,4.267,11.119,4.267,15.386,0c4.267-4.267,4.267-11.119,0-15.451c0,0,0,0-0.065-0.065   c-14.158-14.804-39.628-14.998-54.109,0.065C175.289,88.949,175.289,95.802,179.556,100.133   C179.556,100.069,179.556,100.069,179.556,100.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M287.968,181.523c-5.947,0.711-10.214,6.206-9.503,12.154c0.84,5.689-3.038,12.606-10.796,13.834   c-5.947,0.711-10.214,6.206-9.503,12.154c1.681,6.982,5.947,9.826,12.154,9.503c19.653-1.552,32.582-21.721,29.737-38.077   C299.41,184.949,293.98,180.747,287.968,181.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M196.234,171.051c3.426-4.913,2.133-11.766-2.78-15.127c-5.818-3.943-7.176-11.895-3.232-17.713   c3.426-4.913,2.133-11.766-2.78-15.127c-4.913-3.426-11.766-2.133-15.127,2.78c-10.796,14.352-6.4,39.887,8.727,47.968   C186.02,177.257,192.743,176.028,196.234,171.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M193.778,194.323c-4.267,4.267-4.267,11.119,0,15.451c4.267,4.267,11.119,4.267,15.451,0   c5.56-5.56,14.545-5.56,20.105,0c4.267,4.267,11.119,4.267,15.451,0c4.267-4.267,4.267-11.119,0-15.451   C230.691,180.36,207.806,180.36,193.778,194.323z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiology);
export default __webpack_public_path__ + "static/media/biology.6f045a30337890356bff2c3b04f45169.svg";
export { ForwardRef as ReactComponent };